<template>
  <v-dialog max-width="55%" persistent v-model="dialogShow">
  <v-form onsubmit="return false;" ref="form" lazy-validation>
    <div class="lw-modal-backdrop theme">
      <div class="lw-modal">
        <div class="lw-modal-header">
          <div class="hdr-left">
            <div class="title">Submission Form</div>
          </div>
          <div class="hdr-right">
            <button class="lw-icon-btn" title="Close" @click="closeDialog();">✕</button>
          </div>
        </div>
        <div class="lw-modal-body">
          <div class="lw-modal-grid">
            <div class="lw-modal-col">
              <div class="lw-modal-scroll">
                <div class="section-block">
                  <div class="field-grid-4">
                    <div class="field">
                      <label>Submission Subject (Deal Name)</label>
                      <v-text-field
                        v-model="company.iso_email_subject"  
                        :rules="[v => !!v || 'Email Subject (Deal Name) is required']"
                        required
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                    ></v-text-field>
                    </div>
                    <div class="field">
                      <label>Company Legal Name (required)*</label>
                      <v-text-field
                        v-model="company.company_name"  
                        required
                        v-on:keyup="autoSearchCompany"
                        :rules="[v => !!v || 'Company Name is required']"
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                    ></v-text-field>
                    </div>
                    <div class="field">
                      <label>Doing Business As (DBA) (required)*</label>
                      <v-text-field
                        v-model="company.company_dba"
                        :rules="[v => !!v || 'DBA is required']"
                        v-on:keyup="autoSearchCompanyDBA"
                        required
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                    ></v-text-field>
                    </div>
                    <div class="field">
                      <label>Company Email</label>
                      <v-text-field
                        placeholder="example@mcawizard.com"
                        type="email"
                        v-model="company.company_email"  
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                      ></v-text-field>
                    </div>
                  </div>
                  <div class="field-grid-4">
                    <div class="field">
                      <label>Industry</label>
                      <v-autocomplete
                        v-model="company.company_industry"
                        :items="industry"
                        item-text="company_industry_name"
                        item-value="company_industry_name"
                        persistent-hint
                        required
                        autocomplete
                        class="company-input"
                      ></v-autocomplete>
                    </div>
                    <div class="field">
                      <label>Tax ID</label>
                      <v-text-field
                        v-model="company.company_tax_id"
                        :mask="masks.taxIDmask"
                        v-on:keyup="searchTaxID"
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                    ></v-text-field>
                    </div>
                    <div class="field">
                      <label>Website Link</label>
                      <v-text-field
                        v-model="company.company_website_link"
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                    ></v-text-field>
                    </div>
                    <div class="field">
                      <label>Start Date</label>
                      <v-text-field
                        v-model="company.company_started_date"
                        :mask="masks.monthYearMask"
                        placeholder="mm/yyyy"
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
                <div class="section-block">
                  <div class="section-header-line">
                    <div>
                      <div class="section-heading">Type Of Entity</div>
                    </div>
                  </div>
                  <div class="field-grid-1">
                    <div class="field">
                      <div style="max-height: 18px !important;">
                        <v-radio-group v-model="company.company_type_of_entity" row class="tbl-radio">
                          <v-radio label="Sole Prop" value="Sole Prop"></v-radio>
                          <v-radio label="Partnership" value="Partnership"></v-radio>
                          <v-radio label="Corp" value="Corp"></v-radio>
                          <v-radio label="LLC" value="LLC"></v-radio>
                          <v-radio label="LLP" value="LLP"></v-radio>
                          <v-radio label="Nonprofit" value="Nonprofit"></v-radio>
                          <v-radio label="Others" value="Others"></v-radio>
                        </v-radio-group>
                    </div>
                    </div>
                  </div>
                </div>
                <div class="section-block">
                  <div class="section-header-line">
                    <div>
                      <div class="section-heading">Company Addresses</div>
                    </div>
                  </div>
                  <div class="field-grid-1">
                    <div class="field">
                      <v-alert
                        :value="true"
                        type="warning"
                        v-if="company.addressReturnText.length > 0"
                        class="alert-height"
                      >{{ company.addressReturnText }}</v-alert>

                      <v-alert
                        :value="true"
                        type="error"
                        v-if="company.USPSError.length > 0"
                        class="alert-height"
                      >{{ company.USPSError }}</v-alert>
                    </div>
                  </div>
                  <div class="field-grid-4">
                      <div class="field">
                        <label>Zip Code (required)</label>
                        <v-text-field
                          v-model="company.company_zip"
                          :mask="masks.zipMask"
                          :rules="[v => !!v || 'Company Zip is required']"
                          required
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input"
                        ></v-text-field>
                      </div>
                      <div class="field">
                        <label>Street Address (required)</label>
                        <v-text-field
                          v-model="company.company_street"
                          :rules="[v => !!v || 'Street Address is required']"
                          v-on:change="companyAddressValidate"
                          required
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input"
                        ></v-text-field>
                      </div>
                      <div class="field">
                        <label>City (required)</label>
                        <v-text-field
                          v-model="company.company_city"
                          :rules="[v => !!v || 'Company City is required']"
                          required
                          v-on:change="companyAddressValidate"
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input"
                        ></v-text-field>
                      </div>
                      <div class="field" style="flex-direction: row;">
                        <div style="width: 100%;">
                        <label>State (required)</label>
                        <v-autocomplete
                          v-model="company.company_state"
                          :rules="[v => !!v || 'Company state is required']"
                          :items="statesWithName"
                          item-text="name"
                          item-value="alpha_2"
                          persistent-hint
                          required
                          autocomplete
                          v-on:change="companyAddressValidate"
                          class="company-input"
                        ></v-autocomplete>
                        </div>
                        <div style="display: flex; align-items: flex-end;">
                          <v-icon v-if="company.addressConfirmed" color="green darken-2">check_circle</v-icon>
                          <v-icon v-else color="red lighten-2">highlight_off</v-icon>
                        </div>
                      </div>
                  </div>
                  <div class="field-grid-1">
                    <div class="field">
                      <v-switch
                        :label="mailingNo? 'Click to hide form': 'Click to add Mailing Address if it is different'"
                        v-model="mailingNo"
                        class="mailing-address"
                        hide-details
                      ></v-switch>
                    </div>
                  </div>
                  <div class="field-grid-4" v-if="mailingNo">
                      <div class="field">
                        <label>Mailing Zip Code</label>
                        <v-text-field
                          v-model="company.company_mailing_zip"
                          :mask="masks.zipMask"
                          :rules="[v => !!v || 'Mailing Zip Code is required']"
                          required
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input"
                        ></v-text-field>
                      </div>
                      <div class="field">
                        <label>Mailing Street Address</label>
                        <v-text-field
                          v-model="company.company_mailing_street"
                          :rules="[v => !!v || 'Mailing Street is required']"
                          v-on:change="companyMailingAddressValidate"
                          required
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input"
                        ></v-text-field>
                      </div>
                      <div class="field">
                        <label>Mailing City</label>
                        <v-text-field
                          v-model="company.company_mailing_city"
                          :rules="[v => !!v || 'Mailing City is required']"
                          required
                          v-on:change="companyMailingAddressValidate"
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input"
                        ></v-text-field>
                      </div>
                      <div class="field" style="flex-direction: row;">
                        <div style="width: 100%;">
                        <label>Mailing State</label>
                        <v-autocomplete
                          v-model="company.company_mailing_state"
                          :rules="[v => !!v || 'Mailing State is required']"
                          :items="statesWithName"
                          item-text="name"
                          item-value="alpha_2"
                          persistent-hint
                          required
                          autocomplete
                          v-on:change="companyMailingAddressValidate"
                          class="company-input"
                        ></v-autocomplete>
                        </div>
                        <div style="display: flex; align-items: flex-end;">
                          <v-icon v-if="company.mailingAddressConfirmed" color="green darken-2">check_circle</v-icon>
                          <v-icon color="red lighten-2">highlight_off</v-icon>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="section-block">
                  <div class="entities-header-row">
                    <div>
                      <div class="section-heading">Company Phones</div>
                    </div>
                    <template v-for="(companyPhone, index) in companyPhones" >
                      <button 
                        :key="index"  
                        @click="addNewCompanyPhone" 
                        v-if="index==0" 
                        class="btn-mini primary"
                        >
                        + Add Phone
                      </button>
                    </template>
                  </div>
                  <div class="field-grid-4" v-for="(companyPhone, index) in companyPhones" :key="index">
                    <div class="field">
                        <label>Company Phone</label>
                        <v-text-field
                          v-model="companyPhone.company_phone_number"
                          :mask="masks.phoneMask"
                          placeholder="(###)###-####"
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input inner-icon"
                        >
                          <template v-slot:prepend-inner>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" @click.stop="deleteCompanyPhone(index)">delete_sweep</v-icon>
                              </template>
                              Delete
                            </v-tooltip>
                          </template>
                        </v-text-field>
                    </div>
                    <div class="field">
                        <v-radio-group 
                        v-model="companyPhone.company_phone_type" 
                        persistent-hint
                        return-object 
                        row 
                        class="tbl-radio"
                        style="max-height: 18px !important; margin-top: 20px !important;"
                        >
                          <v-radio label="Mobile" value="Mobile"></v-radio>
                          <v-radio label="Home" value="Home"></v-radio>
                          <v-radio label="Business" value="Business"></v-radio>
                        </v-radio-group>
                    </div>
                  </div>
                </div>
                <div class="section-block">
                  <div class="entities-header-row">
                    <div>
                      <div class="section-heading">Company References</div>
                    </div>
                    <template v-for="(reference, index) in references">
                      <v-tooltip top v-if="index==0" :key="index" style="display: contents;">
                        <template v-slot:activator="{ on }">
                            <button 
                              @click="addNewReference"
                              class="btn-mini primary"
                              v-on="on"
                              >
                              + Add Reference
                            </button>
                        </template>
                        <span>Only need 2 needed</span>
                      </v-tooltip>
                    </template>
                  </div>
                  <div class="field-grid-4" v-for="(reference, index) in references" :key="index">
                    <div class="field">
                        <label>Reference Business Name</label>
                        <v-text-field
                          v-model="reference.reference_business_name"
                          hint="Fill this out if the Company have references."
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input inner-icon"
                        >
                          <template v-slot:prepend-inner>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" @click.stop="deleteReference(index)">delete_sweep</v-icon>
                              </template>
                              Delete
                            </v-tooltip>
                          </template>
                        </v-text-field>
                    </div>
                    <div class="field">
                      <label>Reference Contact Name</label>
                      <v-text-field
                        v-model="reference.reference_contact_name"
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                      ></v-text-field>
                    </div>
                    <div class="field">
                      <label>Reference Phone #</label>
                      <v-text-field
                        v-model="reference.reference_phone_number"
                        :mask="masks.phoneMask"
                        placeholder="(###)###-####"
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
                <div class="section-block">
                  <div class="entities-header-row">
                    <div>
                      <div class="section-heading">Merchants</div>
                    </div>
                    <template v-for="(merchant, i) in merchants">
                      <button 
                        :key="i"
                        v-if="i == 0"
                        @click="addMerchant"
                        class="btn-mini primary"
                        >
                        + Add Merchant
                      </button>

                    </template>
                  </div>
                  <div v-for="(merchant, i) in merchants" :key="i" :class="{ space: i !== 0 }">
                  <div class="section-heading" style="margin-bottom: 10px;">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" v-if="merchants.length > 1" @click="removeMerchant(i)" style="font-size: 16px; margin-bottom: -2px; margin-right: 5px;">delete_sweep</v-icon>
                      </template>
                      Remove Merchant
                    </v-tooltip>
                    <b>Merchant #{{i+1}} Information</b>
                  </div>
                  <div class="field-grid-4">
                    <div class="field">
                        <label>Last name (required)</label>
                        <v-text-field
                          v-model="merchant.merchant_last_name"
                          :rules="[v => !!v || 'Last Name is required']"
                          v-on:keyup="()=>autoSearchMerchant(i)"
                          required
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input"
                        ></v-text-field>
                    </div>
                    <div class="field">
                      <label>First name (required)</label>
                      <v-text-field
                        v-model="merchant.merchant_first_name"
                        :rules="[v => !!v || 'First Name is required']"
                        v-on:keyup="()=>autoSearchMerchant(i)"
                        required
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                      ></v-text-field>
                    </div>
                    <div class="field">
                      <label>Middle name</label>
                      <v-text-field
                        v-model="merchant.merchant_middle_name"
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                      ></v-text-field>
                    </div>
                    <div class="field">
                      <label>Suffix</label>
                      <v-autocomplete
                        v-model="merchant.merchant_suffix"
                        :items="suffixs"
                        persistent-hint
                        autocomplete
                        class="company-input"
                      ></v-autocomplete>
                    </div>
                    </div>
                    <div class="field-grid-5">
                    <div class="field">
                      <label>Date of Birth</label>
                      <v-text-field
                        type="date"
                        v-model="merchant.merchant_date_of_birth"
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                      ></v-text-field>
                    </div>
                    <div class="field">
                      <label>Merchant Email</label>
                      <v-text-field
                        v-model="merchant.merchant_email"
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                      ></v-text-field>
                    </div>
                    <div class="field">
                      <label>SSN</label>
                      <v-text-field
                        v-model="merchant.merchant_ssn"
                        :mask="masks.socialMask"
                        placeholder="###-##-####" 
                        v-on:keyup="()=>searchSSN(i)"
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                      ></v-text-field>
                    </div>
                    <div class="field">
                      <label>Ownership %</label>
                      <v-text-field
                        v-model="merchant.percentage_of_ownership"
                        :mask="masks.percentMask"
                        dense
                        hide-details
                        solo
                        flat
                        class="company-input"
                      ></v-text-field>
                    </div>
                    <div class="field">
                      <label>Merchant Credit Score</label>
                      <vue-numeric
                        separator=","
                        v-bind:precision="0"
                        v-model="merchant.merchant_credit_score"
                      ></vue-numeric>
                    </div>
                    </div>
                    <div class="entities-header-row">
                      <div>
                        <div class="mini-label">Merchants Addresses</div>
                      </div>
                    </div>
                    <div class="field-grid-1" v-if="merchant.addressReturnText.length > 0 || merchant.USPSError.length > 0">
                      <div class="field">
                        <v-alert
                          :value="true"
                          type="warning"
                          v-if="merchant.addressReturnText.length > 0"
                          class="alert-height"
                        >{{ merchant.addressReturnText }}</v-alert>
                        <v-alert
                          :value="true"
                          type="error"
                          v-if="merchant.USPSError.length > 0"
                          class="alert-height"
                        >{{ merchant.USPSError }}</v-alert>
                      </div>
                    </div>
                    <div class="field-grid-4" style="max-height: 47.5px;">
                      <div class="field">
                        <label>Zip Code (required)</label>
                        <v-text-field
                          :mask="masks.zipMask"
                          v-model="merchant.merchant_zip"
                          :rules="[v => !!v || 'Zip Code is required']"
                          required
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input"
                        ></v-text-field>
                      </div>
                      <div class="field">
                        <label>Street Address (required)</label>
                        <v-text-field
                          v-model="merchant.merchant_street"
                          :rules="[
                            v => !!v || 'Street Address is required'
                          ]"
                          required
                          v-on:change="()=>merchantAddressValidate(i)"
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input"
                        ></v-text-field>
                      </div>
                      <div class="field">
                        <label>City (required)</label>
                        <v-text-field
                          v-model="merchant.merchant_city"
                          :rules="[v => !!v || 'City is required']"
                          required
                          v-on:change="()=>merchantAddressValidate(i)"
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input"
                        ></v-text-field>
                      </div>
                      <div class="field" style="flex-direction: row;">
                        <div style="width: 100%;">
                        <label>State (required)</label>
                        <v-autocomplete
                          v-model="merchant.merchant_state"
                          :rules="[v => !!v || 'State is required']"
                          :items="statesWithName"
                          item-text="name"
                          item-value="alpha_2"
                          persistent-hint
                          required
                          autocomplete
                          v-on:change="()=>merchantAddressValidate(i)"
                          class="company-input"
                        ></v-autocomplete>
                        </div>
                        <div style="display: flex; align-items: flex-end;">
                        <v-icon v-if="merchant.addressConfirmed" color="green darken-2">check_circle</v-icon>
                        <v-icon v-else color="red lighten-2">highlight_off</v-icon>
                        </div>
                      </div>
                  </div>
                  <div class="entities-header-row">
                    <div>
                      <div class="mini-label">Merchants Phones</div>
                    </div>
                  </div>
                  <div class="field-grid-4" v-for="(merchantPhone, index) in merchant.merchantPhones" :key="index">
                    <div class="field">
                        <label>Merchant Phone Number (required)</label>
                        <v-text-field
                          v-model="merchantPhone.merchant_phone_number"
                          :rules="[v => !!v || 'Phone is required']"
                          :mask="masks.phoneMask"
                          placeholder="(###)###-####"
                          required
                          dense
                          hide-details
                          solo
                          flat
                          class="company-input inner-icon"
                        >
                          <template v-slot:prepend-inner>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" @click.stop="deletePhone(i,index)">delete_sweep</v-icon>
                              </template>
                              Delete
                            </v-tooltip>
                          </template>
                        </v-text-field>
                    </div>
                    <div class="field">
                        <v-radio-group 
                        v-model="merchantPhone.merchant_phone_type"
                        persistent-hint
                        return-object 
                        row 
                        required
                        class="tbl-radio"
                        style="max-height: 18px !important; margin-top: 20px !important;"
                        >
                          <v-radio label="Mobile" value="Mobile"></v-radio>
                          <v-radio label="Home" value="Home"></v-radio>
                          <v-radio label="Business" value="Business"></v-radio>
                        </v-radio-group>
                    </div>
                    <div class="field">
                      <button 
                        @click="addNewPhone(i)"
                        class="btn-mini primary"
                        style="max-width: 80px; margin-top: auto;"
                        >
                        + Add Phone
                      </button>
                    </div>
                  </div>
                </div>
                </div>
                <div class="section-block">
                  <div class="section-header-line">
                    <div>
                      <div class="section-heading">Upload Files</div>
                    </div>
                  </div>
                  <div class="field-grid-1">
                    <div class="field">
                      <DealFileUpload ref="submitFiles"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="lw-modal-footer">
            <button 
              class="btn-primary" 
              @click="submitSubmission" 
              :disabled="progressModel"
              >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </v-form>
</v-dialog>
</template>

<script>
import axios from "axios";
import _ from 'lodash'
// import ProgressModel from "./ProgressModel.vue";
import moment from "moment";
import { install } from "vuex";
import GeneralHelper from "../../general_helper.js";
import SubFormHelper from "../helpers/sub_form_helper";
import StatesHelper from "../helpers/states_helper";

import DealFileUpload from "./Submission/DealFileUpload";
import { URL } from "../../env";

export default {
  mixins: [GeneralHelper, SubFormHelper, StatesHelper],
  components: {
    DealFileUpload,
    // ProgressModel
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      valid: "",
      progressBar: false,
      note: "",
      files: [],
      progressModel: false,
      merchantPhones: [],
      companyPhones: [
        {
          company_phone_number: "",
          company_phone_type: ""
        }
      ],
      mailingNo: false,
      suffixs: [
        "Jr",
        "Sr",
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
        "1st",
        "2nd",
        "3rd",
        "4th"
      ],
      data_results: [],
      company_data_results: [],
      merchant_data_results: [],
      merchant_company_data_results: [],

      searchData: {
        draw: 0,
        length: 25,
        search: null,
        column: 4,
        dir: "desc"
      },
      merchants: [
        {
          merchant_id: null,
          unique_id: null,
          merchant_first_name: "",
          merchant_middle_name: "",
          merchant_last_name: "",
          merchant_suffix: "",
          merchant_date_of_birth: "",
          merchant_ssn: "",
          merchant_credit_score: "",
          merchant_email: "",
          merchant_note: "",
          percentage_of_ownership: "",
          merchant_street: "",
          merchant_city: "",
          merchant_state: "",
          merchant_zip: "",
          correct_address: [],
          addressReturnText: "",
          USPSError: "",
          addressConfirmed: false,
          merchantPhones: [
            {
              merchant_phone_number: "",
              merchant_phone_type: ""
            }
          ]
        }
      ],
      company: {
        company_id: null,
        unique_id: null,
        company_name: "",
        company_dba: "",
        company_other_entities: "",
        company_started_date: "",
        company_sic_code: "",
        company_tax_id: "",
        iso_email: "",
        company_website_link: "",
        company_cc_monthly_average: "",
        company_twelve_month_sale: "",
        company_type_of_entity: "",
        company_email: "",
        company_industry: "",
        company_blacklisted_industry: "",
        company_isnegative_days: "",
        company_istime_in_business: "",
        company_isHBSP_less: "",
        company_ismin_deposit: "",
        submission_from: "Advantage",
        company_address_type: "",
        company_street: "",
        company_city: "",
        company_state: "",
        company_zip: "",
        company_mailing_street: "",
        company_mailing_city: "",
        company_mailing_state: "",
        company_mailing_zip: "",
        iso_rep_emails: [],
        iso_email_subject: "",
        iso_email_link: "",
        correct_address: [],
        addressReturnText: "",
        USPSError: "",
        addressConfirmed: false,
        mailingAddressReturnText: "",
        mailingUSPSError: "",
        mailingAddressConfirmed: false,
        company_average_negative_days: "",
        company_average_monthly_volume: "",
        company_application_start_date: ""
      },
      company_business: {
        company_id: null,
        landlord_name: "",
        landlord_phone_number: "",
        reference_business_name: "",
        reference_contact_name: "",
        reference_phone_number: "",
        business_intelliscore: "",
        business_financial_stability_score: "",
        business_inquires: "",
        business_current_location_time: "",
        business_current_location_structure: "",
        owner_distance_business: "",
        business_assets: "",
        business_seasonal: "",
        economic_health_of_town: "",
        population_of_business_town: "",
        population_growth_of_business_town: "",
        use_of_funds: "",
        free_from_daily_payments: "",
        monthly_business_rent: ""
      },
      company_reference: {
        company_id: null,
        reference_one_business_name: "",
        reference_one_contact_name: "",
        reference_one_phone_number: "",
        reference_two_business_name: "",
        reference_two_contact_name: "",
        reference_two_phone_number: ""
      },
      deal: {
        deal_id: null,
        unique_id: null
      },
      reference: {
        company_id: null,
        id: null,
        reference_business_name: "",
        reference_contact_name: "",
        reference_phone_number: ""
      },
      references: [
        {
          reference_business_name: "",
          reference_contact_name: "",
          reference_phone_number: ""
        }
      ]
    };
  },
  computed: {
    user_id() {
      return localStorage.getItem("user_id");
    },
    iso_id() {
      return localStorage.getItem("iso_id");
    }
  },
  mounted() {
    this.checkParams();
  },
  methods: {
    checkParams() {
      if (this.$route.params.iso_id && this.$route.params.user_id) {
        this.company.iso_id = parseInt(this.$route.params.iso_id);
        localStorage.setItem('iso_id', this.$route.params.iso_id)
        localStorage.setItem('user_id', this.$route.params.user_id)
      }
    },
    addMerchant() {
      this.merchants.push({
        merchant_id: null,
        unique_id: null,
        merchant_first_name: "",
        merchant_middle_name: "",
        merchant_last_name: "",
        merchant_suffix: "",
        merchant_date_of_birth: "",
        merchant_ssn: "",
        merchant_credit_score: "",
        merchant_email: "",
        merchant_note: "",
        percentage_of_ownership: "",
        merchant_street: "",
        merchant_city: "",
        merchant_state: "",
        merchant_zip: "",
        correct_address: [],
        addressReturnText: "",
        USPSError: "",
        addressConfirmed: false,
        merchantPhones: [
          {
            merchant_phone_number: "",
            merchant_phone_type: ""
          }
        ]
      });
    },
    removeMerchant(index) {
      this.merchants.splice(index, 1);
    },
    addNewReference() {
      this.references.push({
        reference_business_name: "",
        reference_contact_name: "",
        reference_phone_number: ""
      });
    },
    deleteReference(index) {
      this.references.splice(index, 1);
    },
    addNewPhone(index) {
      this.merchants[index].merchantPhones.push({
        merchant_phone_number: "",
        merchant_phone_type: ""
      });
    },
    deletePhone(i, j) {
      this.merchants[i].merchantPhones.splice(j, 1);
    },
    addNewCompanyPhone() {
      this.companyPhones.push({
        company_phone_number: "",
        company_phone_type: ""
      });
    },
    deleteCompanyPhone(index) {
      this.companyPhones.splice(index, 1);
    },
    submitSubmission() {
      let vm = this;
      if (this.$refs.form.validate()) {
        vm.progressModel = true;
        vm.submitMerchants();
      } else {
        const failingInputs = this.$refs.form.inputs.filter(i => i.hasError);
        const messages = failingInputs.flatMap(i => i.errorBucket);
        const msg = messages.length
          ? "Please fix the following:\n• " + messages.join("\n• ")
          : "Please fill out all the required fields.";
        alert(msg);
        if (failingInputs.length) {
          failingInputs[0].$el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    },
    //Method to store Merchant Info
    submitMerchants() {
      this.merchants.forEach((data, index) => {
        this.submitMerchant(data, index);
      });
    },
    submitMerchant: async function(data, index) {
      let vm = this;
      axios
        .post(`${URL}/api/create_merchants`, {
          user_id: this.user_id,
          merchant_first_name: data.merchant_first_name,
          merchant_middle_name: data.merchant_middle_name,
          merchant_last_name: data.merchant_last_name,
          merchant_suffix: data.merchant_suffix,
          merchant_date_of_birth: data.merchant_date_of_birth,
          merchant_ssn: data.merchant_ssn,
          merchant_credit_score: data.merchant_credit_score,
          merchant_email: data.merchant_email,
          merchant_note: data.merchant_note
        })
        .then(function(response) {
          if (response.data.success) {
            let merchant_id = response.data.merchant[0].id;
            data.merchant_id = response.data.merchant[0].id;
            data.unique_id = response.data.merchant[0].unique_id;
            vm.submitMerchantAddress(data, merchant_id);
            vm.submitMerchantPhone(data, merchant_id);
            if (index == vm.merchants.length - 1) {
              vm.submitCompany();
            } else {
              this.progressModel = false;
            }
          }
        })
        .catch(function(error) {
          console.log(error, "Failed to add submission");
        });
    },
    //Method to store Merchant Address Info
    submitMerchantAddress: async function(data, merchant_id) {
      axios.post(`${URL}/api/create_merchant_address`, {
        merchant_id: merchant_id,
        merchant_street: data.merchant_street,
        merchant_city: data.merchant_city,
        merchant_state: data.merchant_state,
        merchant_zip: data.merchant_zip
      });
    },
    //Method to submit company phones
    submitMerchantPhone: async function(data, merchant_id) {
      let vm = this;
      for (let i = 0; i < data.merchantPhones.length; i++) {
        axios
          .post(`${URL}/api/create_merchant_phone`, {
            merchant_id: merchant_id,
            merchant_phone_number: data.merchantPhones[i].merchant_phone_number,
            merchant_phone_type: data.merchantPhones[i].merchant_phone_type
          })
          .then(function(response) {
            if (response.data.success) {
              console.log(response.data.message);
            }
          })
          .catch(function(error) {
            console.log("Error Creating Merchant Phone");
          });
      }
      //location.reload();
    },
    getCreditScoreAvg() {
      let sum = 0;
      this.merchants.forEach(data => {
        sum += data.merchant_credit_score;
      });
      return sum / this.merchants.length;
    },
    submitCompanyMerchants() {
      this.merchants.forEach((data, index) => {
        this.saveCompanyMerchant(data, index);
      });
    },
    //Method to store Merchant Address Info
    saveCompanyMerchant: async function(data, index) {
      let vm = this;
      if (vm.company.company_id !== null && data.merchant_id !== null) {
        await axios
          .post(`${URL}/api/create_company_merchant`, {
            merchant_id: data.merchant_id,
            company_id: vm.company.company_id,
            percentage_of_ownership: data.percentage_of_ownership
          })
          .then(function(response) {
            if (response.data.success) {
              if (index == vm.merchants.length - 1) {
                vm.submitDeal();
              }
            }
          })
          .catch(function(error) {
            console.log(
              "Error submitting cm. Please make sure the address is verified"
            );
          });
      } else {
        alert("Error submitting cm. Please make sure the address is verified");
      }
    },
    //Method to store Deal Info
    async submitDeal() {
      let vm = this;
      if (this.company.company_id !== null) {
        let diff = this;
        diff = moment(new Date()).diff(
          moment(this.company.company_started_date, "MMYYYY"),
          "years",
          true
        );
        const response = await axios.post(`${URL}/api/create_submission`, {
          user_id: vm.user_id,
          iso_id: this.iso_id,
          company_id: vm.company.company_id,
          deal_name: vm.company.iso_email_subject,
          deal_type: "New Deal",
          deal_next_processor_role: "Data Entry",
          iso_rep_emails: vm.mapIsoRepEmails(),
          iso_email_subject: vm.company.iso_email_subject,
          iso_email_link: vm.company.iso_email_link,
          deal_note: this.note,
          company_industry: this.company.company_industry,
          company_zip: this.company.company_aip,
          deal_avg_monthly_vol: this.company.deal_avg_monthly_vol,
          deal_avg_negative_days: this.company.deal_avg_negative_days,
          deal_year_diff: Number(diff.toFixed(1)),
          merchant_credit_score: this.getCreditScoreAvg()
        });
        if (response.data.success) {
          vm.deal = response.data.success

          this.$refs.submitFiles.submitSelectedFileSection(vm.deal);

          let deal_id = response.data.success.id;
          let unique_id = response.data.success.unique_id;
          vm.deal.deal_id = deal_id;
          vm.deal.unique_id = unique_id;

          const resp = await axios.post(
            `${URL}/api/create_sub_note`,
            {
              user_id: vm.user_id,
              deal_id: vm.deal.deal_id,
              pinned: 0,
              deal_user_note: vm.note,
              deal_note_type: null,
              deal_note_processor_role: "iso" // this.user.role
            }
          );
          if (resp) {
            vm.progressModel = false;
            //Set Flash message
            vm.flash(response.data.message, "success", {
              timeout: 3000
            });
            // window.close()
            this.closeDialog()
          }
        } else {
          //Set Flash message
          vm.flash(response.data.message, "error", {
            timeout: 3000
          });
        }
      } else {
        alert("Error Adding Deal Merchant");
      }
    },
    submitCompany: async function() {
      let vm = this;
      axios
        .post(`${URL}/api/create_company`, {
          user_id: this.user_id,
          iso_id: this.iso_id,
          company_name: this.company.company_name,
          company_dba: this.company.company_dba,
          company_other_entities: this.company.company_other_entities,
          company_started_date: this.company.company_started_date,
          company_sic_code: this.company.company_sic_code,
          company_tax_id: this.company.company_tax_id,
          iso_email: this.company.iso_email,
          company_website_link: this.company.company_website_link,
          company_cc_monthly_average: this.company.company_cc_monthly_average,
          company_twelve_month_sale: this.company.company_twelve_month_sale,
          company_type_of_entity: this.company.company_type_of_entity,
          company_email: this.company.company_email,
          company_industry: this.company.company_industry,
          company_blacklisted_industry: this.company
            .company_blacklisted_industry,
          company_isnegative_days: this.company.company_isnegative_days,
          company_istime_in_business: this.company.company_istime_in_business,
          company_isHBSP_less: this.company.company_isHBSP_less,
          company_ismin_deposit: this.company.company_ismin_deposit,
          iso_rep_emails: this.mapIsoRepEmails()
        })
        .then(function(response) {
          if (response.data.success) {
            console.log(response.data.message);
            let company_id = response.data.company[0].id;
            let unique_id = response.data.company[0].unique_id;
            vm.company.company_id = company_id;
            vm.company.unique_id = unique_id;
            //create company address
            console.log("create company address");
            vm.submitCompanyMaintAddress(company_id, 'Main');
            //Create company phones
            vm.submitCompanyPhone(company_id);
            //Create contact work History
            vm.submitContactWorkHistory(company_id);
            //Create Reference Info
            vm.submitCompanyReference(company_id);
            if (vm.company.company_mailing_street.length >= 1) {
              //Create Company Mailing address
              vm.submitCompanyMailingAddress(company_id, 'Mailing');
            }
            vm.submitCompanyMerchants();
          }
        })
        .catch(function(error) {
          console.log("Error Creating Company");
        });
      //Create Company Merchant
    },
    //Method to store Company Reference Info
    submitCompanyReference: async function(company_id) {
      let vm = this;
      for (let i = 0; i < this.references.length; i++) {
        await axios
          .post(`${URL}/api/create_company_reference`, {
            company_id: company_id,
            reference_business_name: this.references[i].reference_business_name,
            reference_contact_name: this.references[i].reference_contact_name,
            reference_phone_number: this.references[i].reference_phone_number
          })
          .then(function(response) {
            if (response.data.success) {
              vm.flash(response.data.message, "success", {
                timeout: 3000
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            vm.flash("Error Creating Company Reference", "success", {
              timeout: 3000
            });
          });
      }
    },
    //Method to store Company Main Address Info
    submitCompanyMaintAddress: async function(company_id, type) {
      let vm = this;
      // await axios.post('/api/company_address/company_addresses', {
      axios
        .post(`${URL}/api/create_company_address`, {
          company_id: company_id,
          company_street: this.company.company_street,
          company_city: this.company.company_city,
          company_state: this.company.company_state,
          company_zip: this.company.company_zip,
          company_address_type: type
        })
        .then(function(response) {
          if (response.data.success) {
            console.log(response.data.message);
          }
        })
        .catch(function(error) {
          console.log("Error Creating Company Main Address");
        });
    },
    //Method to store Company Mailing Address Info
    submitCompanyMailingAddress: async function(company_id, type) {
      let vm = this;
      await axios
        .post(`${URL}/api/create_company_address`, {
          company_id: company_id,
          company_street: this.company.company_mailing_street,
          company_city: this.company.company_mailing_city,
          company_state: this.company.company_mailing_state,
          company_zip: this.company.company_mailing_zip,
          company_address_type: type
        })
        .then(function(response) {
          if (response.data.success) {
            console.log(response.data.message);
          }
        })
        .catch(function(error) {
          console.log("Error Creating Company Mailing Address");
        });
    },
    //Method to submit company phones
    submitCompanyPhone: async function(company_id) {
      let vm = this;
      for (let i = 0; i < this.companyPhones.length; i++) {
        // await  axios.post('/api/company_phone/company_phones', {
        axios
          .post(`${URL}/api/create_company_phone`, {
            company_id: company_id,
            company_phone_number: vm.companyPhones[i].company_phone_number,
            company_phone_type: vm.companyPhones[i].company_phone_type
          })
          .then(function(response) {
            if (response.data.success) {
              console.log(response.data.message);
            }
          })
          .catch(function(error) {
            console.log("Error Creating Company Phone");
          });
      }
      //location.reload();
    },
    //Method to store Company Work History Info
    submitContactWorkHistory: async function(company_id) {
      let vm = this;
      // await axios.post('/api/contact_work_history/contact_work_histories', {
      axios
        .post(`${URL}/api/create_contact_work_history`, {
          company_id: company_id,
          user_id: this.user_id
        })
        .then(function(response) {
          if (response.data.success) {
            console.log(response.data.message);
          }
        })
        .catch(function(error) {
          console.log("Error Creating Company Main Address");
        });
    },
    //Autocomplete for merchant first name and last name
    autoComplete() {
      this.data_results = [];
      if (
        this.merchant.merchant_first_name.length >= 2 ||
        this.merchant.merchant_last_name.length >= 2
      ) {
        axios
          .get(`${URL}/api/merchant/merchant_search`, {
            params: {
              merchant_first_name: this.merchant.merchant_first_name,
              merchant_last_name: this.merchant.merchant_last_name,
              merchant_ssn: this.merchant.merchant_ssn
            }
          })
          .then(response => {
            console.log(response);
            this.data_results = response.data;
          });
      }
    },
    //Validate by SSN tested
    async searchSSN(i) {
      try {
        if (this.merchants[i].merchant_ssn.length >= 9) {
          // const response = await this.$store.dispatch(
          //   "merchants/searchMerchantSSN",
          //   this.merchants[i].merchant_ssn
          // );
          const response = await axios.get(`${URL}/api/mechant_ssn_search`, {
            params: {
              merchant_ssn: this.merchants[i].merchant_ssn
            }
          });
          if (response.data.merchant.length > 0) {
            alert(
              "There is already a merchant with this SSN: " +
                this.merchants[i].merchant_ssn
            );
            this.merchants[i].merchant_ssn = null;
            this.merchant_data_results = response.data.merchant;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    //Validate by Tax ID tested
    async searchTaxID() {
      try {
        if (this.company.company_tax_id.length >= 9) {
          // const response = await this.$store.dispatch(
          //   "companies/searchTaxID",
          //   this.company.company_tax_id
          // );
          const response = await axios.get(`${URL}/api/company_search_tax_id`, {
            params: {
              company_tax_id: this.company.company_tax_id
            }
          });
          if (response.data.length > 0) {
            alert(
              "There is already a company with this Tax ID: " +
                this.company.company_tax_id
            );
            this.company.company_tax_id = null;
            this.company_data_results = response.data;
          } else {
            this.company_data_results = response.data;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    //Auto complete for merchant name
    autoSearchMerchant(i) {
      if(!this.$route.params.user_id){
        this.progressBar = true;
        this.getAutoSearchMerchant(i);
      }
    },
    getAutoSearchMerchant: _.debounce(async function(e) {
      const response = await axios.get(`${URL}/api/merchant/merchant_search`, {
        params: {
          merchant_first_name: this.merchants[e].merchant_first_name,
          merchant_last_name: this.merchants[e].merchant_last_name,
          merchant_ssn: this.merchants[e].merchant_ssn
        }
      });
      this.merchant_data_results = response.data;
      this.progressBar = false;
    }, 3000),
    //Auto complete for company name tested
    async autoSearchCompanyDBA() {
      if(!this.$route.params.user_id){
        this.progressBar = true;
        this.getAutoSearchCompanyDBA();
      }
    },
    getAutoSearchCompanyDBA: _.debounce(async function(e) {
      let payload = {
        draw: 1,
        length: 25,
        search: this.company.company_dba,
        column: 4,
        dir: "desc"
      };
      this.searchData.draw++;
      const response = await axios
        .get(`${URL}/api/company/companies`, { params: payload })
        // const response = await this.$store
        //   .dispatch("companyTable/searchCompanies", { params: payload })
        .then(resp => {
          this.company_data_results = resp.data.data;
          this.progressBar = false;
        });
    }, 3000),
    autoSearchCompany() {
      if(!this.$route.params.user_id){
        this.progressBar = true;
        this.getAutoSearchCompany();
      }
    },
    getAutoSearchCompany: _.debounce(async function(e) {
      let payload = {
        draw: 1,
        length: 25,
        search: this.company.company_name,
        column: 4,
        dir: "desc"
      };
      this.searchData.draw++;
      // const response = await this.$store
      //   .dispatch("companyTable/searchCompanies", { params: payload })
      const response = await axios
        .get(`${URL}/api/company/companies`, { params: payload })
        .then(resp => {
          this.company_data_results = resp.data.data;
          this.progressBar = false;
        });
    }, 3000),
    //Validate Company Address
    async companyAddressValidate() {
      if (
        this.company.company_street.length > 0 &&
        this.company.company_city.length > 0 &&
        this.company.company_state.length > 0
      ) {
        // const response = await this.$store.dispatch(
        //   "merchants/getAddressValidation",
        //   {
        //     params: {
        //       street: this.company.company_street,
        //       city: this.company.company_city,
        //       state: this.company.company_state
        //     }
        //   }
        // );
        const response = await axios.get(`${URL}/usps_address_validation`, {
          params: {
            street: this.company.company_street,
            city: this.company.company_city,
            state: this.company.company_state
          }
        });
        if (response.data.data.Address.Address2) {
          this.company.company_street = response.data.data.Address.Address2;
          this.company.company_city = response.data.data.Address.City;
          this.company.company_state = response.data.data.Address.State;
          this.company.company_zip = response.data.data.Address.Zip5;
          this.company.addressConfirmed = true;
          this.company.USPSError = "";
          if (response.data.data.Address.ReturnText) {
            this.company.addressReturnText =
              response.data.data.Address.ReturnText;
          } else {
            this.company.addressReturnText = "";
          }
        } else {
          this.company.company_zip = "";
          this.company.addressReturnText = "";
          this.company.USPSError = response.data.data.Address.Error.Description;
          this.company.addressConfirmed = false;
        }
      }
    },
    //Validate Company Mailing Address
    async companyMailingAddressValidate() {
      if (
        this.company.company_mailing_street.length > 0 &&
        this.company.company_mailing_city.length > 0 &&
        this.company.company_mailing_state.length > 0
      ) {
        // const response = await this.$store.dispatch(
        //   "merchants/getAddressValidation",
        //   {
        //     params: {
        //       street: this.company.company_mailing_street,
        //       city: this.company.company_mailing_city,
        //       state: this.company.company_mailing_state
        //     }
        //   }
        // );
        const response = await axios.get(`${URL}/usps_address_validation`, {
          params: {
            street: this.company.company_mailing_street,
            city: this.company.company_mailing_city,
            state: this.company.company_mailing_state
          }
        });
        if (response.data.data.Address.Address2) {
          this.company.company_mailing_street =
            response.data.data.Address.Address2;
          this.company.company_mailing_city = response.data.data.Address.City;
          this.company.company_mailing_state = response.data.data.Address.State;
          this.company.company_mailing_zip = response.data.data.Address.Zip5;
          this.company.mailingAddressConfirmed = true;
          this.company.mailingUSPSError = "";
          if (response.data.data.Address.ReturnText) {
            this.company.mailingAddressReturnText =
              response.data.data.Address.ReturnText;
          } else {
            this.company.mailingAddressReturnText = "";
          }
        } else {
          this.company.company_mailing_zip = "";
          this.company.mailingAddressReturnText = "";
          this.company.mailingUSPSError =
            response.data.data.Address.Error.Description;
          this.company.mailingAddressConfirmed = false;
        }
      }
    },
    //tested
    async merchantAddressValidate(i) {
      if (
        this.merchants[i].merchant_street.length > 0 &&
        this.merchants[i].merchant_city.length > 0 &&
        this.merchants[i].merchant_state.length > 0
      ) {
        // const response = await this.$store.dispatch(
        //   "merchants/getAddressValidation",
        //   {
        //     params: {
        //       street: this.merchants[i].merchant_street,
        //       city: this.merchants[i].merchant_city,
        //       state: this.merchants[i].merchant_state
        //     }
        //   }
        // );
        const response = await axios.get(`${URL}/usps_address_validation`, {
          params: {
            street: this.merchants[i].merchant_street,
            city: this.merchants[i].merchant_city,
            state: this.merchants[i].merchant_state
          }
        });
        if (response.data.data.Address.Address2) {
          this.merchants[i].merchant_street =
            response.data.data.Address.Address2;
          this.merchants[i].merchant_city = response.data.data.Address.City;
          this.merchants[i].merchant_state = response.data.data.Address.State;
          this.merchants[i].merchant_zip = response.data.data.Address.Zip5;
          this.merchants[i].addressConfirmed = true;
          this.merchants[i].USPSError = "";
          if (response.data.data.Address.ReturnText) {
            this.merchants[i].addressReturnText =
              response.data.data.Address.ReturnText;
          } else {
            this.merchants[i].addressReturnText = "";
          }
        } else {
          this.merchants[i].merchant_zip = "";
          this.merchants[i].addressReturnText = "";
          this.merchants[i].USPSError =
            response.data.data.Address.Error.Description;
          this.merchants[i].addressConfirmed = false;
        }
      }
    },
    mapIsoRepEmails() {
      return this.company.iso_rep_emails.map(item => {
        if (item.iso_contact_email) {
          return item.iso_contact_email;
        } else return item;
      });
    },
    closeDialog() {
      this.$emit("ondialogClosed");
    },
  }
};
</script>

<style scoped src="./Shared/Styles/Form.css"></style>

<style scoped>
.inner-icon >>> i.v-icon {
  font-size: 16px !important;
}

.radios >>> i.v-icon {
  font-size: 17px !important;
}

.radios >>> .v-input--selection-controls__input {
  margin-right: 0px !important;
}

.company-input >>> .v-text-field__details {
  position: absolute !important;
  margin-top: 21px !important;
}

.date-field.v-input--is-readonly >>> input {
  cursor: pointer !important;
}

.stitle{
    font-size:11px;
    font-weight:600;
    color:#0f172a;
    white-space:nowrap;
}

.tbl-radio {
    padding-left: 8px !important;
    height: 30px !important;
    margin-top: 0px !important;
    padding-top: 0px !important;
}

.tbl-radio .v-icon {
  font-size: 18px !important;
}

.tbl-radio >>> label {
  margin-bottom: 0px !important;
  margin-top: -7px !important;
  font-size: 12px !important;
}

.tbl-radio >>> .v-input--selection-controls__input {
  margin-right: -3px !important; /* Reduce gap between radio and label */
}

.tbl-radio >>> .v-icon {
  font-size: 16px !important;
}

.tbl-radio >>> .v-input__slot {
    margin-bottom: 0px !important;
}

.tbl-radio >>> .v-input.tbl-radio {
    margin-top: 0px !important;
    max-height: 18px !important;
}

.alert-height {
  min-height: 35px !important;
  height: auto !important;
  padding: 0px 16px !important;
}

.mailing-address {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

.mailing-address >>> .v-label {
  font-size: 9px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.07em !important;
  color: #6b7280 !important;
  margin-bottom: 2px !important;
}

.mailing-address >>> .v-input__slot {
  margin-bottom: 0px !important;
}

.space {
  margin-top: 20px;
}

>>> .v-dialog {
  box-shadow: none !important;
}
</style>